import { useState } from "react";
import Menu from "../../Helpers/menu";
import { useTranslation } from "react-i18next";
import Loading from "../Layout/Components/Loading";
import FixedTable from "../Layout/Components/Table/FixedTable";
import {
    FileEarmarkMedicalFill,
    PlusCircle,
    PencilSquare,
} from "react-bootstrap-icons";
import { useContract } from "../../Hook/Contract/useContract";
import ContractForm from "./ContractForm";

export default function Contracts({ idClient, listContracts }) {
    const { t } = useTranslation(); // Translation hook

    const { contracts, loading, setSearch, setReload } = useContract({
        idClient,
        listContracts,
    });

    // Edit User
    // Use null to represent no contract selected (avoid passing empty objects)
    const [contract, setContract] = useState(null);
    // Manupuladores do formulário
    const [showContractForm, setShowContractForm] = useState(false); // Show contract form
    const editContract = (row) => {
        setContract(row);
        setShowContractForm(true);
    };
    const handleFormClose = () => {
        setContract(null);
        setShowContractForm(false);
        setReload();
    };

    // Column definitions
    const tableColumns = [
        { field: "id", label: "#", type: "number" },
        {
            field: "client.name",
            label: t("contract.table.client"),
            type: "string",
        },
        {
            field: "description",
            label: t("contract.table.description"),
            type: "string",
        },
        {
            field: "is_active",
            label: t("contract.table.is_active"),
            type: "boolean",
        },
        {
            field: "create_user.name",
            label: t("contract.table.create_user"),
            type: "string",
        },
        {
            field: "create_at",
            label: t("contract.table.create_at"),
            type: "date",
        },
        {
            field: "update_user.name",
            label: t("contract.table.update_user"),
            type: "string",
        },
        {
            field: "update_at",
            label: t("contract.table.update_at"),
            type: "date",
        },
        {
            field: "actions",
            label: t("contract.table.actions"),
            type: "actions",
            actions: [
                {
                    icon: <PencilSquare />,
                    handle: editContract,
                },
            ],
        },
    ];

    const menuItens = [
        {
            type: "button",
            label: t("contract.menu.create"),
            icon: <PlusCircle />,
            action: () => {
                setShowContractForm(true);
            },
        },
    ];

    return (
        <>
            <Menu
                icon={<FileEarmarkMedicalFill />}
                search={setSearch}
                clean={() => setSearch("")}
                menu={menuItens}
                placeholderSearch="contract.menu.search"
            />
            <ContractForm
                show={showContractForm}
                onClose={handleFormClose}
                idClient={idClient}
                contract={contract}
            />
            {loading ? (
                <Loading />
            ) : (
                <FixedTable
                    table="contracts"
                    columns={tableColumns}
                    data={contracts}
                    reload={() => setReload()}
                    empty={t("contract.table.empty")}
                />
            )}
        </>
    );
}
